export const ALERT_DIALOG_ID = "ALERT_DIALOG_ID";
